import { render, staticRenderFns } from "./UserUnpaidTab.vue?vue&type=template&id=1c28bfae&"
import script from "./UserUnpaidTab.vue?vue&type=script&lang=js&"
export * from "./UserUnpaidTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VSkeletonLoader,VTabItem})
